import React from 'react'

import { applyStyle } from '../helpers/styles'

export const useDisplayStyle = props => {
  const { display, inline, block, inlineBlock, overflow } = props

  return React.useMemo(() => {
    const displayValue = display || (!!inline && 'inline') || (!!block && 'block') || (!!inlineBlock && 'inline-block')

    return `
      ${applyStyle('display', displayValue)}
      ${applyStyle('overflow', overflow)}
    `
  }, [display, inline, block, inlineBlock, overflow])
}
